import api from "./GpartsEditApi";
import GPart from "../models/GPart";
import GPartType from "../models/GPartType";
import PartGroup from "../models/PartGroup";
import UnitType from "../models/UnitType";
import Tax from "../models/Tax";
import TaxItem from "../models/TaxItem";
import CarCostType from "../models/CarCostType";
import OtherCostType from "../models/OtherCostType";
import GpartOtherCostType from "../models/GpartOtherCostType";

export class GpartsEditStore {
    gpart = new GPart();
    types: GPartType[] = [];
    partGroups: PartGroup[] = [];
    currencies: string[] = [];
    unitTypes: UnitType[] = [];
    taxes: Tax[] = [];
    taxItems: TaxItem[] = [];
    carCostTypes: CarCostType[] = [];
    otherCostTypes: OtherCostType[] = [];
    gpartOtherCostRelations: GpartOtherCostType[] = [];

    async loadType() {
        this.types = await api.getTypes();
    }

    async loadPartGroups() {
        this.partGroups = await api.getPartGroups();
    }

    async loadCurrencies() {
        this.currencies = await api.getCurrencies();
    }

    async loadUnitTypes() {
        this.unitTypes = await api.getUnitTypes();
    }

    async loadTaxes() {
        this.taxes = await api.getTaxes();
    }

    async loadTaxItems(){
        this.taxItems = await api.getTaxItems(this.gpart.tax);
    }

    async loadCarCostTypes(){
        this.carCostTypes = await api.getCarCostTypes();
    }

    async loadOtherCostTypes(){
        this.otherCostTypes = await api.getOtherCostTypes();
    }

    async loadGpartOtherCostRelations(){
        // Csak "fő" cikknél (nem maga egyéb költség cikk) van értelme a hozzárendelésnek
        if (this.gpart.id > 1 && this.gpart.otherCostType <= 1) {
            this.gpartOtherCostRelations = await api.getGpartOtherCostRelations(this.gpart.id);
        } else {
            this.gpartOtherCostRelations = [];
        }
    }

    async loadGpart(id: number){
        this.gpart = await api.getGpart(id);
    }

    async updateGpart(){
        this.gpart.id = await api.updateGpart(this.gpart);
        if (this.gpart.otherCostType <= 1) {
            const ocostGpartIds = this.gpartOtherCostRelations
                .map(r => r.selectedOcostGpartId)
                .filter(id => id > 1);
            await api.saveGpartOtherCostRelations(this.gpart.id, ocostGpartIds);
        }
    }
}

const store = new GpartsEditStore();
export default store;